import { render, staticRenderFns } from "./AdviseCenter.vue?vue&type=template&id=0002b0bc&scoped=true"
import script from "./AdviseCenter.vue?vue&type=script&lang=js"
export * from "./AdviseCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002b0bc",
  null
  
)

export default component.exports